import React, {Fragment} from "react";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

import DashboardAppbar from "../../components/common/DashboardAppbar";
import DashboardDrawer from "../../components/common/DashboardDrawer";
import {useAuth} from "../../context/AuthProvider";

function DashboardGuard(props) {
    let {user} = useAuth();
    let location = useLocation();

    const [drawerOpen, setDrawerOpen] = React.useState(true);
    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };
    if (!user) {
        return <Navigate to={"/auth/login"} state={{from: location}} replace={true}/>
    } else if (!user.admin) {
        return <Navigate to={"/"} state={{from: location}} replace={true}/>
    }
    return (
        <Fragment>
            <Box sx={{display: "flex"}}>
                <DashboardAppbar drawerOpen={drawerOpen} toggleDrawer={toggleDrawer}/>
                <DashboardDrawer drawerOpen={drawerOpen} toggleDrawer={toggleDrawer}/>
                <Box
                    component="main"
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.mode === "light"
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: "100vh",
                        overflow: "auto",
                    }}
                >
                    <Toolbar/>
                    <Outlet/>
                </Box>
            </Box>
        </Fragment>
    );
}

export default DashboardGuard;
